export default __webpack_public_path__ + "static/media/front.8ce6f52d.png";